import { Column, CreateDateColumn, Entity,  PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('rm_price_list')
export class RmPriceList{

    @PrimaryGeneratedColumn("increment" ,{name:'rm_price_list_id'})
    rmPriceListId:number;

    @Column("date",{
        name:"date",
        nullable:false
    })
    date:Date;

    @Column("varchar",{
        name:"min_count",
        length:30,
        nullable:false
    })
    minCount:number;

    @Column("varchar",{
        name:"max_count",
        length:30,
        nullable:false
    })
    maxCount:number;

    @Column("varchar",{
        name:"price",
        length:30,
        nullable:false
    })
    price:number;

    @Column("boolean",{
        name:"is_active",
        default:true,
        nullable:false
    })
    isActive:boolean;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    updateAt:Date;

    @Column("varchar", {
        nullable: false,
        default:1,
        name: "created_user"
    })
    createdUser: string | null;
  
  
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar",{
        nullable : true,
        name: "updated_user"
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
  createdAt: Date;

}